import { Component } from '@angular/core';
import { CoreSignalLanguageEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Languages') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-coresignallanguage-form',
    templateUrl: './coresignallanguage.form.component.html'
})
export class CoreSignalLanguageFormComponent extends BaseFormComponent {
    public record!: CoreSignalLanguageEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

